import { render, staticRenderFns } from "./staking.vue?vue&type=template&id=c80a3448&scoped=true&"
import script from "./staking.vue?vue&type=script&lang=js&"
export * from "./staking.vue?vue&type=script&lang=js&"
import style0 from "./staking.vue?vue&type=style&index=0&id=c80a3448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80a3448",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c80a3448')) {
      api.createRecord('c80a3448', component.options)
    } else {
      api.reload('c80a3448', component.options)
    }
    module.hot.accept("./staking.vue?vue&type=template&id=c80a3448&scoped=true&", function () {
      api.rerender('c80a3448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/mining/staking/staking.vue"
export default component.exports